import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, ArrowRight, BookOpen } from 'lucide-react';
import { CHAKRAS, IMAGES, FAQS } from '../mock';

const Wellness = () => {
  return (
    <div className="pt-28 pb-24">
      <section className="relative py-20 overflow-hidden">
        <div className="absolute inset-0">
          <img src={IMAGES.crystals} alt="" className="w-full h-full object-cover opacity-20" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0a0708] via-[#0a0708]/80 to-[#0a0708]" />
        </div>
        <div className="relative max-w-3xl mx-auto px-5 text-center">
          <p className="font-jost text-xs tracking-[0.4em] text-[#ff4da6] uppercase mb-4">Wellness & Learn</p>
          <h1 className="font-cinzel text-4xl md:text-6xl text-gold-gradient leading-tight">Crystal Chakra Healing</h1>
          <div className="gold-divider my-6" />
          <p className="font-cormorant text-xl md:text-2xl text-[#f5ecd9]/75 leading-relaxed">A holistic practice focused on the body's energy centers — the chakras — to restore balance and harmony. Using healing crystals, herbs and botanical rituals, we cleanse, balance and restore your energy system for greater clarity and wellbeing.</p>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-5 py-12">
        <div className="space-y-5">
          {CHAKRAS.map((c) => (
            <div key={c.name} className="card-glass rounded-2xl p-6 md:p-8 flex items-center gap-6 hover-lift">
              <span className="block h-16 w-16 rounded-full flex-shrink-0" style={{ background: c.color, boxShadow: `0 0 30px ${c.color}` }} />
              <div className="flex-1">
                <div className="flex items-baseline gap-3 flex-wrap"><h3 className="font-cinzel text-2xl text-[#f5ecd9]">{c.name}</h3><span className="font-cormorant italic text-lg text-[#f0d582]">{c.sanskrit}</span></div>
                <p className="font-jost text-sm text-[#f5ecd9]/65 mt-1">{c.focus}</p>
              </div>
              <div className="text-right flex-shrink-0"><p className="font-jost text-[10px] uppercase tracking-widest text-[#f5ecd9]/40">Crystal</p><p className="font-cinzel text-sm text-[#ff4da6] mt-1">{c.crystal}</p></div>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-5 py-12">
        <div className="text-center mb-12"><h2 className="font-cinzel text-3xl md:text-4xl text-gold-gradient">Your Daily Ritual</h2><div className="gold-divider mt-4" /></div>
        <div className="grid md:grid-cols-3 gap-7">
          {[
            { n: '01', t: 'Cleanse', d: 'Purify your skin and space with pure botanicals and sage to release what no longer serves you.' },
            { n: '02', t: 'Balance', d: 'Align your energy centers with crystals chosen for each chakra and set your intention.' },
            { n: '03', t: 'Restore', d: 'Nourish deeply with body-oil rituals that leave you glowing inside and out.' },
          ].map((s) => (
            <div key={s.n} className="card-glass rounded-2xl p-8 text-center"><div className="font-cinzel text-5xl text-pink-gradient mb-4">{s.n}</div><h3 className="font-cinzel text-xl text-[#f5ecd9] mb-2">{s.t}</h3><p className="font-jost text-sm text-[#f5ecd9]/60 leading-relaxed">{s.d}</p></div>
          ))}
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-5 py-12">
        <div className="text-center mb-8"><BookOpen className="h-8 w-8 text-[#f0d582] mx-auto mb-3" /><h2 className="font-cinzel text-3xl text-gold-gradient">Frequently Asked</h2><div className="gold-divider mt-4" /></div>
        <div className="space-y-4">
          {FAQS.map((f, i) => (
            <div key={i} className="card-glass rounded-xl p-6"><h3 className="font-cinzel text-lg text-[#f0d582] mb-2">{f.q}</h3><p className="font-jost text-sm text-[#f5ecd9]/70 leading-relaxed">{f.a}</p></div>
          ))}
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-5 text-center">
        <div className="card-glass rounded-3xl p-12">
          <Sparkles className="h-10 w-10 text-[#f0d582] mx-auto mb-4" />
          <h2 className="font-cinzel text-3xl text-gold-gradient">Begin Your Healing Journey</h2>
          <p className="font-cormorant text-xl text-[#f5ecd9]/70 mt-3 mb-8">Explore our crystals and body oils, or book a session with our practitioners.</p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/shop?category=crystals" className="inline-flex items-center justify-center gap-2 text-[#f0d582] border border-[#d4af37]/40 rounded-full px-8 py-3.5 hover:bg-[#d4af37]/10 transition-colors font-jost text-sm tracking-widest uppercase">Shop Crystals</Link>
            <Link to="/book" className="btn-gold inline-flex items-center justify-center gap-2 rounded-full px-8 py-3.5 text-sm font-semibold text-[#0a0708] bg-gradient-to-r from-[#d4af37] via-[#f0d582] to-[#d4af37]">Book A Session <ArrowRight className="h-4 w-4" /></Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Wellness;
